import css from 'styled-jsx/css';

const styles = css.global`#seguros-conteudos {
  background-color: #fbfbfb;
  padding-top: 32px;
  padding-bottom: 40px;
}

#seguros-conteudos .is-desk {
  display: none;
}

#seguros-conteudos .is-mobi {
  overflow: hidden;
}

#seguros-conteudos .ctn-home-24 {
  position: relative;
}

#seguros-conteudos .seguros-conteudos-titulo {
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: 60px;
  margin-bottom: 16px;
}

#seguros-conteudos .seguros-conteudos-slide {
  display: flex;
  justify-content: center;
  margin-right: 16px;
  margin-left: 0;
  flex: 0 0 272px;
}

#seguros-conteudos .seguros-conteudos-card {
  display: flex;
  flex-direction: column;
  color: #fff;
  width: 272px;
  min-height: 348px;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid #ccc;
}

#seguros-conteudos picture {
  width: 100%;
}

#seguros-conteudos img {
  width: 100%;
  height: 189px;
  object-fit: cover;
  border-radius: 4px;
}

#seguros-conteudos .seguros-conteudos-card-textos {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 178px;
  padding: 8px 16px 11px;
}

#seguros-conteudos .seguros-conteudos-slide-titulo {
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
  margin: 0;
}

#seguros-conteudos .seguros-conteudos-slide-link {
  color: #C00;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 155.556% */
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}

#seguros-conteudos .custom-carousel.embla {
  margin-bottom: 18px;
}


#seguros-conteudos .home-pagination {
  width: 100%;
  max-width: 288px;
  margin-left: auto;
  margin-right: auto;
}

#seguros-conteudos .home-pagination .enable-mobile-arrows {
  height: 24px;
  width: 24px;
  background-size: 24px 24px;
}

@media (min-width: 992px) {

  #seguros-conteudos { 
    padding-top: 88px;
    padding-bottom: 88px;
  }

  #seguros-conteudos .is-mobi {
    display: none;
  }

  #seguros-conteudos .is-desk {
    display: flex;
    flex-direction: column;
    position: relative;
    margin: auto;
  }

  #seguros-conteudos .cards-desk {
    display: flex;
    justify-content: space-between;
  }

  #seguros-conteudos .seguros-conteudos-card {
    width: 100%;
    max-width: 379px;
    min-height: 369px;
  }

  #seguros-conteudos .seguros-conteudos-card-textos {
    padding: 8px 16px 32px;
  }

}

@media(max-width: 992px){
  #seguros-conteudos .seguros-conteudos-card {
    min-height: 388px;
  }
}`;

export default styles;